import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { FileSelector } from "components/base/Form";
import { Alert } from "components/base/Toast";
import useFileUploader from "hooks/useFileUploader";
import { getOriginalFileName } from "utils/string";
import { SAVE_SUPPLIER } from "./graphql";

const DocumentsView = ({ supplier }) => {
  const { isUploading, handleFileUpload } = useFileUploader(
    handleUploadedFiles,
    "qiniu",
  );
  const [save, saveRes] = useMutation(SAVE_SUPPLIER, {
    onCompleted() {
      Alert("success", "Documents updated successfully");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  console.log("supplier", supplier);

  function handleUploadedFiles(urls) {
    console.log("Uploaded file URLs:", urls);
    const documentUrls = [...supplier.documentUrls, ...urls];
    save({ variables: { id: supplier.id, documentUrls } });
  }

  function deleteHandler(index) {
    if (window.confirm("Are you sure you want to delete this document?")) {
      const newUrls = [...supplier.documentUrls];
      newUrls.splice(index, 1);
      save({ variables: { id: supplier.id, documentUrls: newUrls } });
    }
  }

  return (
    <div className="card space-y-2">
      <h5>Documents</h5>

      {supplier.documentUrls.length > 0 && (
        <div className="-mx-2">
          <table>
            <tbody>
              {supplier.documentUrls.map((url, index) => (
                <tr
                  key={index}
                  className="border-y border-gray-100 dark:border-gray-700"
                >
                  <td className="w-full">
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {getOriginalFileName(url)}
                    </a>
                  </td>
                  <td>
                    <div className="flex justify-end">
                      <Button trash onClick={() => deleteHandler(index)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex items-center space-x-3">
        <FileSelector
          title="+ Upload Documents"
          uploading={isUploading || saveRes.loading}
          onChange={(e) => {
            const files = [...e.target.files];
            handleFileUpload(files);
            e.target.value = null;
          }}
        />
      </div>
    </div>
  );
};

export default DocumentsView;
